/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  about: () => import("@/views/about/index.vue"),
  contact: () => import("@/views/contact/index.vue"),
  home: () => import("@/views/home/index.vue"),
  "industry-trends": () => import("@/views/industry-trends/index.vue"),
  legal: () => import("@/views/legal/index.vue"),
  "membership-advantage_advanced-tech-system": () => import("@/views/membership-advantage/advanced-tech-system/index.vue"),
  "membership-advantage_community-support": () => import("@/views/membership-advantage/community-support/index.vue"),
  "membership-advantage_cost-reduction": () => import("@/views/membership-advantage/cost-reduction/index.vue"),
  "membership-advantage_financial-tax-consulting": () => import("@/views/membership-advantage/financial-tax-consulting/index.vue"),
  "membership-advantage_increase-turnover": () => import("@/views/membership-advantage/increase-turnover/index.vue"),
  "membership-advantage_marketing-promotion": () => import("@/views/membership-advantage/marketing-promotion/index.vue"),
  "membership-advantage_membership-program": () => import("@/views/membership-advantage/membership-program/index.vue"),
  "membership-advantage_procurement-cost-optimization": () => import("@/views/membership-advantage/procurement-cost-optimization/index.vue"),
  "membership-advantage_smart-ordering-platform": () => import("@/views/membership-advantage/smart-ordering-platform/index.vue"),
  "membership-advantage_sustainability": () => import("@/views/membership-advantage/sustainability/index.vue"),
  question: () => import("@/views/question/index.vue"),
  service: () => import("@/views/service/index.vue"),
  supplier: () => import("@/views/supplier/index.vue"),
};
